<div class="dialog">
  @if (createCustomerLoading() || getCountriesLoading()) {
    <div class="loading-overlay">
      <mat-progress-spinner mode="indeterminate" diameter="40" />
    </div>
  }

  <div class="dialog__header">
    <h2>{{ 'customers.createCustomer.title' | translate }}</h2>
    <button class="dialog__header-close" (click)="onCancel()">
      <app-icon class="dialog__header-cross-icon" [icon]="iconName.CLOSE" />
    </button>
  </div>

  <form class="form" [formGroup]="customerForm" (ngSubmit)="onSave()">
    <div class="form-fields">
      <div class="field">
        <mat-label>{{ 'customers.createCustomer.firstName.label' | translate }}</mat-label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <input
            matInput
            id="firstName"
            formControlName="firstName"
            [placeholder]="'customers.createCustomer.firstName.placeholder' | translate"
            type="text"
          />
          @if (customerForm.get('firstName')?.hasError('invalidName')) {
            <mat-error>
              {{ 'customers.createCustomer.firstName.invalidName' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="field">
        <mat-label>{{ 'customers.createCustomer.lastName.label' | translate }}</mat-label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <input
            matInput
            id="lastName"
            formControlName="lastName"
            [placeholder]="'customers.createCustomer.lastName.placeholder' | translate"
            type="text"
          />
          @if (customerForm.get('lastName')?.hasError('invalidName')) {
            <mat-error>
              {{ 'customers.createCustomer.lastName.invalidName' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="field">
        <mat-label>{{ 'customers.createCustomer.email.label' | translate }}</mat-label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <input
            matInput
            id="email"
            formControlName="email"
            [placeholder]="'customers.createCustomer.email.placeholder' | translate"
            type="email"
          />
          @if (customerForm.get('email')?.hasError('invalidEmail')) {
            <mat-error>
              {{ 'customers.createCustomer.email.invalidEmail' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="field">
        <mat-label>{{ 'customers.createCustomer.phoneNumber.label' | translate }}</mat-label>
        <div
          class="phone-field"
          [class.has-error]="hasPhoneError"
          [class.is-focused]="isPhoneFocused()"
        >
          <mat-form-field appearance="outline" class="phone-field__country">
            <mat-select formControlName="countryId" (focus)="onPhoneFocus()" (blur)="onPhoneBlur()">
              <mat-select-trigger>
                <span class="phone-field__country-code">
                  {{ getCountryCode() }} ({{ getPhoneCode() }})
                </span>
              </mat-select-trigger>
              @for (country of countries; track country.id) {
                <mat-option [value]="country.id">
                  <span>{{ country.name }} ({{ country.phoneCode }})</span>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="phone-field__number">
            @if (phonePrefix()) {
              <span matTextPrefix class="phone-field__prefix">{{ phonePrefix() }}</span>
            }
            <input
              matInput
              id="phoneNumber"
              formControlName="phoneNumber"
              [placeholder]="'customers.createCustomer.phoneNumber.placeholder' | translate"
              type="tel"
              [mask]="phoneMask"
              (focus)="onPhoneFocus()"
              (blur)="onPhoneBlur()"
            />
          </mat-form-field>
        </div>
        @if (hasPhoneError) {
          <div class="phone-field__error">
            {{ 'customers.createCustomer.phoneNumber.pattern' | translate }}
          </div>
        }
      </div>

      <div class="field full-width">
        <mat-label>{{ 'customers.createCustomer.remarks.label' | translate }}</mat-label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <textarea
            matInput
            class="field__remarks"
            id="remarks"
            formControlName="remarks"
            [placeholder]="'customers.createCustomer.remarks.placeholder' | translate"
            type="text"
          ></textarea>
          @if (customerForm.get('remarks')?.hasError('invalidRemarks')) {
            <mat-error>
              {{ 'customers.createCustomer.remarks.invalidRemarks' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div class="form-actions">
      <button type="button" class="btn-cancel" (click)="onCancel()">
        {{ 'customers.createCustomer.buttons.cancel' | translate }}
      </button>
      <button type="submit" class="btn-add">
        {{ 'customers.createCustomer.buttons.add' | translate }}
      </button>
    </div>
  </form>
</div>
